/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const membershipWithTeamResponseSchema = z.object({
  commitment: z.number(),
  commitmentOverridden: z.boolean(),
  endDate: z.iso.date().nullish(),
  membershipId: z.int(),
  membershipSourceId: z.string().nullish(),
  resourceId: z.int().nullish(),
  roleId: z.int().nullish(),
  sourceCommitment: z.number(),
  startDate: z.iso.date().nullish(),
  teamId: z.int(),
  teamName: z.string(),
});
